import { Observable } from 'rxjs/Rx';
import { ReplaySubject } from 'rxjs/Rx';
import { ClipboardDirective } from './../shared/directives/clipboard.directive';
import { CustomDSValidators } from './../shared/validators/custom-validators';
import { ResponseService } from './../services/response.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from './../services/api.service';
import { IpmiService } from './../services/ipmi.service';
import { LocalStorageService } from './../services/local-storage.service';
import { NotificationsService } from 'angular2-notifications';
import { ServerProperty } from './../interfaces/server/server-property.model';
import { Server } from './../interfaces/server/server.model';
import { ServerNetwork } from './../interfaces/server/server-network.model';
import { OperatingSystem } from './../interfaces/server/operating-system.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Clipboard from "clipboard";
import * as ip from "ip";
import { FormService } from '../services/form.service';
import { MenuService } from './../services/menu.service';


@Component({
	selector: 'app-server-dashboard',
	templateUrl: './server-dashboard.component.html'
})

export class ServerDashboardComponent implements OnInit {

  public showChangeServerName: Boolean = false;

  public changeServerDetailsForm: FormGroup;

	p: number = 1;
	p2: number = 1;
	ptrP: number = 1;

	recordPtrValue: string = '';

	public ptrForm: FormGroup;

	// IP dostępowe do IPMI
	public allowedMyIP: boolean;

	// Formularz IPMI
	public IPMIAccessForm: FormGroup;

	// Dane IPMI
	public IPMIData = <any>{};

	private selectedServiceId: String;

	// ID serwera (ID elementu kontraktu);
	public serviceID: String | null = null;

	// ID kontraktu
	public contractID: String | null = null;

	// Stan serwera
	public serverStatus: Boolean | null = null;

	// Zmienna odwiedlajaca czy pobierany lub zmieniany jest stan serwera
	public checkingStatus: Boolean = true;

	// Zmienna mówiąca o pobieraniu danych
	public loadingServerData: Boolean = true;

	// Parametry serwera
	public serverParameters: Array<ServerProperty>;

	// Obiekt serwera
	public server: Server;

	// Zmienna opisująca czy serwer jest gotowy
	public serverIsReadyObservable: ReplaySubject<Boolean> = new ReplaySubject(1);
	public serverIsReady: Boolean;
	// Zmienna opisująca typ produktu
	public serviceType: string = '';

	// Sieć serwera
	public serverNetwork: Array<any>;

	// Sieć serwera - główna
	public mainServerNetwork: Array<any>;

	// Hasło do systemu operacyjnego
	public serverOSPassword: string = '';
	// Login do systemu operacyjnego
	public serverOSLogin: string = '';

	// Obiekt systemu operacyjnego
	public serverOS: OperatingSystem = { name: '', login: '' };

	// Metody biblioteki IP
	public ipMethods = ip;

	// Form revDNS
	public revDNSForm: FormGroup

	// RevDNS Hint
	public revDNSNotificationHint: Boolean = false;

	// Selected Subnet to modal
	public modalElements: any = { prefix: '127.0.0.1', prefix_len: 32, ips: [] };

	// Server PTR records for ips
	public ptrRecords: any = null;

	// Selected PTR record to edit
	public ptrRecord: any = null;

	//public rrdData : Array<any>;

	public controls = {
		value: new FormControl(''),
	};

	public validators = {
		value: [Validators.required, Validators.maxLength]
	};

  /**
   * Creates an instance of ServerDashboardComponent.
   * @param {ApiService} apiService
   * @param {LocalStorageService} localStorageService
   * @param {NotificationsService} notificationsService
   * @param {IpmiService} ipmiService
   * @param {ActivatedRoute} router
   *
   * @memberOf ServerDashboardComponent
   */
	constructor(
		private apiService: ApiService,
		private localStorageService: LocalStorageService,
		private notificationsService: NotificationsService,
		private ipmiService: IpmiService,
		private responseService: ResponseService,
		private route: ActivatedRoute,
		private router: Router,
    private formService: FormService,
    private menuService: MenuService,

	) {

		this.revDNSForm = new FormGroup({
			subnet_id: new FormControl(null, [Validators.required]),
			ip: new FormControl(null, [Validators.required]),
			ip_id: new FormControl(null, [Validators.required]),
			rev_dns: new FormControl(null, [Validators.required, CustomDSValidators.revDNS]),
			type: new FormControl(null, [Validators.required]),
			family: new FormControl(null, [Validators.required])
		});

		this.IPMIAccessForm = new FormGroup({
			allowed_ip: new FormControl('', [Validators.required, CustomDSValidators.IPWithMask]),
			id: new FormControl(null)
		});
		this.ptrForm = this.formService.buildForm(this.controls, this.validators);
	}



  /**
   * Funkcja inicjalizujaca
   *
   *
   * @memberOf ServerDashboardComponent
   */
	ngOnInit() {
		this.serverIsReadyObservable.next(false);
		this.route.params.subscribe(params => {
			this.serviceID = String(params['service']);
			this.contractID = String(params['contract']);

			this.getServerInfo(this.contractID, this.serviceID);

			this.serverIsReadyObservable.subscribe(
				(ready) => {
					this.serverIsReady = ready;
					this.serverStatus = true;
					//this.getServerRRD(this.serverId);
				}
			);
			//console.log(this.rrdData);
		});
	}

  /**
   * Pobranie informacji o serwerze
   *
   * @private
   * @param {Number} contractId
   * @param {Number} serviceId
   *
   * @memberOf ServerDashboardComponent
   */
	formatBytes(a, b) { if (0 == a) return "0 Bytes"; var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] }

	formatBytesWithUnlimited(a, b) { if (0 == a) return "Bez limitu"; var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] }

	parseFloatValues(a, b) { return parseFloat(a.toFixed(b)); }

	// private getServerRRD(serverID: Number): void{

	//   this.apiService.get('/rrd/' + serverID).subscribe(
	//     (response) => {
	//       const data = this.responseService.success(false, response, 'data');
	//       this.rrdData = data;
	//       //console.log(data);
	//     },
	//     (error) => {
	//       this.responseService.error(error);
	//     }
	//   );
	// }

	private getServerInfo(contractId: String, serviceId: String): void {
		this.loadingServerData = true;
		this.apiService.get('/company/' + this.localStorageService.get('company') + '/contract/' +
			contractId + '/service/' + serviceId).subscribe(
				(response) => {
					const service = this.responseService.success(false, response, 'service');
					this.server = service.server;
					var status = service.server.status === 'active';
					this.serverIsReadyObservable.next(status);
					if (status) {
						this.serverParameters = service.product ? service.product.options : null;
						this.serviceType = service.type;

						const network = response.data.network;
						this.mainServerNetwork = network.filter(i => { return i.type === 'main'; });
						this.mainServerNetwork.forEach(f => {
							f.ips = f.ips.filter(i => { return i.ip_type !== 'net' && i.ip_type !== 'broadcast'; });
						});
						this.serverNetwork = network.filter(i => {
							return i.type !== 'main';
						});
						this.serverNetwork.forEach(f => {
							f.ips = f.ips.filter(i => { return i.ip_type !== 'net' && i.ip_type !== 'broadcast'; });
						});
						this.serverOS = { name: '', login: '' };
						if (service.server.operating_system) {
							this.serverOS = service.server.operating_system;
						}
						this.ptrRecords = response.data.ptrRecords;
						this.checkingStatus = false;
						this.serverStatus = response.data.power_status;
					}
					this.loadingServerData = false;
				},
				(error) => {
					this.responseService.error(error);
				}
			);
	}

  /**
   * Odswiezenie statusu serwera
   *
   * @private
   * @param {String} serviceId
   *
   * @memberOf ServerDashboardComponent
   */
	private refreshServerStatus(serviceId: String): void {
		this.checkingStatus = true;
		this.ipmiService.powerGet(serviceId).then(
			(status) => {
				this.serverStatus = status;
				this.checkingStatus = false;
			},
			(error) => {
				this.notificationsService.error('Ups!', 'Błąd podczas pobierania informacji stanie serwera.');
			}
		);
	}

	private openIPMI(serviceId: String, modal: any) {
		this.selectedServiceId = serviceId;
		this.getIPMIData();
		this.accessForCurrentIP();
		modal.open();
	}

	private accessForAll() {
		this.IPMIAccessForm.controls['allowed_ip'].setValue('0.0.0.0');
		this.allowedMyIP = false;
	}

	private accessForCurrentIP() {
		this.apiService.get('/current_ip').subscribe(
			response => {
				const ip = this.responseService.success(false, response, 'ip');
				this.IPMIAccessForm.controls['allowed_ip'].setValue(ip);
				this.allowedMyIP = true;
			}
		);
	}

	private getIPMIData() {
		this.route.params.subscribe(params => {
			this.IPMIAccessForm.controls['id'].setValue(this.selectedServiceId);
			this.ipmiService.ipmiServer(this.selectedServiceId).subscribe(
				(ipmiData) => {
					this.IPMIData = ipmiData;
				},
				(error) => {
					// console.log('ERROR');
					// console.log(error);
				}
			);
		});
	}

	public getIPMIAccess() {
		this.ipmiService.startNAT(this.IPMIAccessForm.value);
		this.getIPMIData();
	}

	private stopNAT() {
		this.ipmiService.stopNAT(this.IPMIAccessForm.controls['id'].value);
		this.getIPMIData();
	}

  /**
   * Włacznie / wylaczanie servera
   *
   * @private
   * @param {String} type
   *
   * @memberOf ServerDashboardComponent
   */
	public onOffServer(type: String, modal: any): void {
		this.checkingStatus = true;
		this.notificationsService.info(type === 'off' ? 'Wyłączanie serwera' : 'Włączanie serwera', 'Trwa wykonywanie operacji');
		this.ipmiService.powerOnOff(this.serviceID, type).then(
			(status) => {
				const self = this;
				setTimeout(function () {
					self.notificationsService.remove();
					self.checkingStatus = false;
					if (type === 'off') {
						self.serverStatus = false;
						self.notificationsService.success('Sukces!', 'Twój serwer został wyłączony');
					} else {
						self.serverStatus = true;
						self.notificationsService.success('Sukces!', 'Twój serwer został włączony');
					}
				}, 4500);
			},
			(error) => {
				this.notificationsService.remove();
				this.checkingStatus = false;
				if (type === 'off') {
					this.notificationsService.error('Ups', 'Błąd podczas wyłączania serwera');
				} else {
					this.notificationsService.error('Ups', 'Błąd podczas włączania serwera');
				}
			}
		);

		modal.close();
	}

  /**
   * Restartuje serwer
   *
   * @private
   *
   * @memberOf ServerDashboardComponent
   */
	private restartServer(modal: any): void {
		this.checkingStatus = true;
		this.notificationsService.info('Restart', 'Trwa inicjowanie restartu serwera...', 10);
		this.ipmiService.powerReset(this.serviceID).then(
			(status) => {
				const self = this;
				setTimeout(function () {
					self.notificationsService.remove();
					self.checkingStatus = false;
					self.ipmiService.setServerStatus(true);
					self.notificationsService.success('Sukces', 'Twój serwer został zrestartowany');
				}, 5000);
			},
			(error) => {
				this.checkingStatus = false;
				this.notificationsService.error('Ups', 'Błąd podczas restartu serwera');
			}
		);

		modal.close();
	}

  /**
   * Pobranie hasła systemu operacyjnego
   *
   * @private
   * @param {*} modal
   * @memberof ServerDashboardComponent
   */
	private showOSDataModal(modal: any): void {
		this.apiService.get('/company/' + this.localStorageService.get('company') + '/contract/' +
			this.contractID + '/service/' + this.serviceID + '/os_password').map(os => os).subscribe(
				(response) => {
					if (!response.status) {
						this.notificationsService.error('Ups!', 'Brak ustawionego hasła');
					} else {
						this.serverOSPassword = response.password;
						this.serverOSLogin = response.login;
						modal.open();
					}
				},
				(error) => {
					this.notificationsService.error('Ups!', 'Błąd podczas pobierania hasła.');
				}
			);
	}

	private getNetwork() {
		this.apiService.get('/company/' + this.localStorageService.get('company') + '/contract/' +
			this.contractID + '/service/' + this.serviceID + '/network').subscribe(
				(response) => {
					const network = this.responseService.success(false, response, 'network');
					this.serverNetwork = network;
				},
				(error) => {
					this.notificationsService.error('Ups!', 'Błąd podczas pobierania sieci.');
				}
			);
	}

	private getServersIP(ips) {
		return ips.filter(x => x.ip_type === 'server');
	}

	private getServerGateway(ips) {
		for (let ip of ips) {
			if (ip['ip_type'] === 'gateway') {
				return ip['ip_address'];
			}
		}
		return '';
	}

	private showIPS(subnet: any, modal: any) {
		this.modalElements = subnet;
		this.p2 = 1;
		modal.open();
	}

	private showPtr(ptrRecord: any, modal: any) {
		this.ptrRecord = ptrRecord;
		this.ptrForm.controls['value'].setValue(this.ptrRecord.value);
		modal.open();
	}

	private updatePtr(ptrRecord: any, modal: any) {
		if (this.ptrForm.touched) {
			if (this.ptrForm.valid) {
				this.apiService.put(`/company/${this.localStorageService.get('company')}/service/${this.serviceID}/ptr/${ptrRecord.uuid}`, this.ptrForm.value).subscribe(response => {
					this.notificationsService.success('Zapis poprawny', response.message);
					this.getServerInfo(this.contractID, this.serviceID);
					modal.close();
				}, (error) => {
					this.responseService.error(error, this.ptrForm);
				});
				return;
			}
			return this.notificationsService.error('Popraw błędy', 'Popraw wskazany przez system błąd');
		}
		this.notificationsService.info('Brak zmian', 'Wprowadź zmiany na rekordzie aby go zapisać');
	}

	private getModalElements() {
		const ips = this.modalElements.ips.filter(i => { return i.ip_type !== 'gateway'; });
		return ips;
	}

	private showRevDNSModal(modal, ip, rev_dns, subnet_id, ip_id, type, family) {
		// this.revDNSForm.setValue({
		//   subnet_id: subnet_id,
		//   ip: ip,
		//   ip_id: ip_id,
		//   rev_dns: rev_dns,
		//   type: type,
		//   family: family
		// });
		// modal.open();
	}

	public changeRevDNS(modal) {
		this.apiService.put('/company/' + this.localStorageService.get('company') + '/contract/' +
			this.contractID + '/service/' + this.serviceID + '/change_rev_dns', this.revDNSForm.value).subscribe(
				(response) => {
					this.responseService.success(true, response);
					modal.close();
				},
				(error) => {
					this.notificationsService.error('Ups!', 'Błąd podczas aktualizacji revDNS.');
				}
			);
	}

	public newMessage() {
		this.router.navigateByUrl('messages/new?severity=1&service=' + this.serviceID);
	}

	public goToBuyServices()
	{
		this.router.navigateByUrl('/service/offer?for_service=' + this.serviceID);
	}

  showChangeServerNameForm() {
    this.showChangeServerName = true;
    this.changeServerDetailsForm = new FormGroup({
      name_external: new FormControl(this.server['name_external'], [Validators.required]),
      customer_comment: new FormControl(this.server['customer_comment'], [Validators.maxLength(1000)])
    });
  }

  changeServerName() {
    this.apiService.post('/company/' + this.localStorageService.get('company') + '/contract/' + this.contractID + '/service/' + this.serviceID, this.changeServerDetailsForm.value).subscribe(
      (response) => {
        this.server.name_external = this.changeServerDetailsForm.controls['name_external'].value;
        this.server.customer_comment = this.changeServerDetailsForm.controls['customer_comment'].value;
        this.showChangeServerName = false;
        this.responseService.success(true, response);
        this.menuService.getMenuStructure();
      },
      (error) => {
        this.responseService.error(error);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/server/server-dashboard.component.ts